import { render, staticRenderFns } from "./funds.vue?vue&type=template&id=a4558654&"
import script from "./funds.vue?vue&type=script&lang=js&"
export * from "./funds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports